import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CpslButton, CpslIcon, CpslText } from '@usecapsule/react-components';
import { styled } from 'styled-components';
import { ModalStep } from '../../utils/steps.js';
import { useModalStore } from '../../stores/index.js';
import { useThemeStore } from '../../stores/theme/useThemeStore.js';
import { CapsuleBlack, CapsuleWhite } from '../Icons.js';
import { useGoBack } from '../../hooks/useGoBack.js';
export const Header = ({ onClose, condenseModal }) => {
    const logo = useThemeStore(state => state.getLogo());
    const isDark = useThemeStore(state => state.isDark);
    const bareModal = useThemeStore(state => state.bareModal);
    const appName = useThemeStore(state => state.appName);
    const currentStep = useModalStore(state => state.step);
    const hasPreviousStep = useModalStore(state => state.hasPreviousStep());
    const goBack = useGoBack();
    const handleBackClick = () => {
        goBack();
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Container, { slot: "header", id: "header", children: [_jsx(BackButton, { variant: "ghost", style: {
                            visibility: hasPreviousStep ? 'visible' : 'hidden',
                        }, onClick: handleBackClick, children: _jsx(CpslIcon, { icon: "arrowNarrow" }) }), _jsx(CenterTextContainer, { children: currentStep === ModalStep.SIGN_UP ? (_jsx(CenterText, { children: _jsx("span", { children: "Sign Up or Log In" }) })) : (_jsx(_Fragment, { children: logo ? (_jsx(Logo, { src: logo, alt: `${appName ? `${appName} -` : ''}logo` })) : (_jsx(LogoSvg, { children: isDark ? _jsx(CapsuleWhite, {}) : _jsx(CapsuleBlack, {}) })) })) }), _jsx(CloseButton, { bareModal: bareModal, variant: "ghost", onClick: onClose, children: _jsx(CpslIcon, { icon: "close" }) })] }), _jsx(Container, { slot: "footerExpandedHeader", style: { paddingBottom: 0 }, children: _jsxs(ExpandedContainer, { onClick: condenseModal, children: [_jsx(UpArrow, { icon: "arrow" }), _jsx(BackText, { children: _jsx("span", { children: "Back" }) })] }) })] }));
};
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-bottom: 16px;
`;
const HeaderButton = styled(CpslButton) `
  flex: 0;
  --button-padding-top: 0px;
  --button-padding-bottom: 0px;
  --button-padding-start: 0px;
  --button-padding-end: 0px;

  cpsl-icon {
    --height: 20px;
    --width: 20px;
  }
`;
const CloseButton = styled(HeaderButton) `
  transform: rotate(180deg);
  visibility: ${({ bareModal }) => (bareModal ? 'hidden' : 'visible')};
`;
const BackButton = styled(HeaderButton) `
  transform: rotate(180deg);
`;
const CenterTextContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CenterText = styled(CpslText) `
  font-size: 14px;
  color: var(--cpsl-color-text-secondary);
`;
const BackText = styled(CenterText) `
  font-size: 12px;
`;
const Logo = styled.img `
  height: 20px;
  max-width: 60%;
  object-fit: contain;
  box-sizing: content-box;
`;
const LogoSvg = styled.div `
  height: 20px;
  align-self: center;

  svg {
    height: 20px;
  }
`;
const UpArrow = styled(CpslIcon) `
  transform: rotate(-90deg);

  --icon-color: var(--cpsl-color-text-secondary);
`;
const ExpandedContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1;
  cursor: pointer;
`;
